import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Button, Pagination } from "antd";
import { saveAs } from "file-saver";
import { DownloadOutlined } from "@ant-design/icons";

import { ContentLoader } from "../ContentLoader";
import { i18, trb } from "@utilities";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfDocView = ({ documentId, onClick, showButtons, authTypes, buttonTitle }) => {
  const [url, setUrl] = useState("");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [width, setWidth] = useState(null);

  useEffect(() => {
    const url = `${process.env.REACT_APP_API}Document/Get/${documentId}`;
    setUrl(url);
    setDivSize();
    window.addEventListener("resize", setDivSize);

    return () => {
      window.removeEventListener("resize", setDivSize);
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const handlePageChange = page => {
    setPageNumber(page);
  };
  const setDivSize = () => {
    const element = document.getElementById("pdfWrapper");
    setWidth(element.getBoundingClientRect().width);
  };

  const documentData = () => {
    return (
      <Document
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={
          <div style={{ paddingTop: 60 }}>
            <ContentLoader size={width <= 361 ? 34 : 48} />
          </div>
        }
      >
        <Page pageNumber={pageNumber} width={width} />
      </Document>
    );
  };
  const pagination = () => (
    <Pagination
      hideOnSinglePage={true}
      pageSize={1}
      current={pageNumber}
      onChange={handlePageChange}
      defaultCurrent={1}
      total={numPages}
      className="text-center my-2"
      showLessItems={true}
      size={width <= 361 ? "small" : "default"}
    />
  );
  const handleClickOpenPDF = () => {
    const oReq = new XMLHttpRequest();
    oReq.open("GET", url, true);
    oReq.responseType = "blob";
    // When the file request finishes
    // Is up to you, the configuration for error events etc.
    oReq.onload = () => {
      // Once the file is downloaded, open a new window with the PDF
      // Remember to allow the POP-UPS in your browser
      const file = new Blob([oReq.response], {
        type: "application/pdf"
      });
      // Generate file download directly in the browser !
      saveAs(file, `${documentId}.pdf`);
    };
    oReq.send();
  };

  return (
    <div className="pdf-doc-view-wrapper">
      <div className={numPages ? "pdf-doc-view-top" : "hidden"}>
        <span onClick={handleClickOpenPDF} style={{ padding: 5 }}>
          <DownloadOutlined className="pdf-doc-view-img" />
          <a className="pdf-doc-view-link">Download PDF</a>
        </span>
      </div>
      {showButtons && numPages && authTypes && (
        <div className="d-flex justify-content-around flex-wrap">
          {authTypes.map(authType => (
            <Button
              key={authType}
              id={`pdf-button-${authType}`}
              className="mb-3 mr-1"
              type="primary"
              onClick={() => onClick(authType)}
            >
              {trb(i18.Labels[authType])}
            </Button>
          ))}
        </div>
      )}
      {showButtons && numPages && !authTypes && (
        <Button id="pdf-button" className="pdf-doc-view-btn mb-3" onClick={onClick} type="primary">
          {buttonTitle ? buttonTitle : "Continue"}
        </Button>
      )}
      {pagination()}
      <div id="pdfWrapper" style={{ width: "100%" }}>
        {documentData()}
      </div>
      {pagination()}
      {showButtons && numPages && authTypes && (
        <div className="d-flex justify-content-around flex-wrap">
          {authTypes.map(authType => (
            <Button
              key={authType}
              id={`pdf-button-${authType}`}
              className="mb-3 mt-3 mr-2"
              type="primary"
              onClick={() => onClick(authType)}
            >
              {trb(i18.Labels[authType])}
            </Button>
          ))}
        </div>
      )}
      {showButtons && numPages && !authTypes && (
        <Button
          id="pdf-button"
          className="pdf-doc-view-btn mb-3 mt-3"
          onClick={onClick}
          type="primary"
        >
          {buttonTitle ? buttonTitle : "Continue"}
        </Button>
      )}
    </div>
  );
};

export default PdfDocView;
